export interface BurgerProps {
  isOpen: boolean;
  onClick: () => void;
  size?: "default" | "large";
}

export const Burger = ({ isOpen, onClick, size = "default" }: BurgerProps) => {
  const isLarge = size === "large";
  const barClass = isLarge ? "h-0.5 w-6" : "h-0.5 w-5";
  const openOffsetClass = isLarge ? "translate-y-[7px]" : "translate-y-[6px]";
  const closeOffsetClass = isLarge ? "-translate-y-[7px]" : "-translate-y-[6px]";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative flex items-center justify-center rounded-full border transition-colors ${
        isLarge ? "h-12 w-12" : "h-10 w-10"
      } ${
        isOpen
          ? "border-amber-200 bg-amber-200 text-[#1f2d18]"
          : "border-white/60 text-white hover:bg-white/10"
      }`}
      aria-expanded={isOpen}
      aria-label={isOpen ? "Fermer le menu" : "Ouvrir le menu"}
    >
      <span
        className={`absolute block rounded-full bg-current transition-transform duration-300 ${barClass} ${
          isOpen ? "rotate-45" : closeOffsetClass
        }`}
      />
      <span
        className={`absolute block rounded-full bg-current transition-all duration-300 ${barClass} ${
          isOpen ? "scale-x-0 opacity-0" : "opacity-100"
        }`}
      />
      <span
        className={`absolute block rounded-full bg-current transition-transform duration-300 ${barClass} ${
          isOpen ? "-rotate-45" : openOffsetClass
        }`}
      />
    </button>
  );
};
